import { useEffect, useState } from 'react';
import Button from 'react-bootstrap/Button';
import Col from 'react-bootstrap/Col';
import Form from 'react-bootstrap/Form';
import Row from 'react-bootstrap/Row';
import useApi from '../../hooks/UseApi';
import { useNavigate, useParams } from 'react-router-dom';
import useAuthentication from '../../auth/useAuthentication';
import { toast } from 'react-toastify';


function GridComplexExample() {

  const navigate = useNavigate();
  const context = useAuthentication();
  const { get, post, updating, showError } = useApi();


  const [ validated, setValidated ] = useState(false);
  const [ email, setEmail ] = useState('');
  const [ role, setRole ] = useState('');
  const [ username, setUsername ] = useState('');
  const [ password, setPassword ] = useState('');
  const [ machines, setMachines ] = useState([]);
  const [ selectedMachines, setSelectedMachines ] = useState([]);
  const { id } = useParams();


  const handleCheckboxChange = (e) => {
    const { value, checked } = e.target;
    setSelectedMachines(prev =>
      checked
        ? [...prev, value]
        : prev.filter(id => id !== value)
    );
  };


  useEffect(() => {
    // console.log('context.user.role',context.user.role)
    // setMachines(elements);
    // get('users/machines').then(r => {
    //   const elements = [ ];
    //   for (let k in r.data) {
    //     let element = r.data[k];
    //     element.id = k;
    //     elements.push(element);
    //   }
    //   setMachines(elements);
    // });

    // const elements = [ ];
    // for (let k in context.user.machines) {
    //   let element = context.user.machines[k];
    //   element.id = k;
    //   elements.push(element);
    // }
    // console.log('context.user.machines', context.user.machines)
    // console.log('elements', elements)
    // setMachines(elements);
    setMachines(context.user.machines);


    if (id) {
      get('users/' + id).then(r => {
        setEmail(r.data.email);
        setUsername(r.data.username);
        setRole(r.data.role);
        setSelectedMachines(r.data.machines);
      });
    }
  }, []);


  const handleChange = (setState) => (event) => {
    setState(event.target.value);
  };



  const handleSubmit = (event) => {
    event.preventDefault();

    // return console.log(selectedMachines)
    // if (group == '' || (id && values.length == 0)) {
    //   setValidated(true);
    //   if (values.length == 0) {
    //     showError('Debe cargar al menos un valor');
    //   }
    // } else {

    if (role != 'ROOT' && role != 'ADMIN' && role != 'USER') {
      toast.error(<div>El rol es requerido</div>);
      return;
    }
    if (email.trim().length == 0) {
      toast.error(<div>El email es requerido</div>);
      return;
    }
    if (username.trim().length == 0) {
      toast.error(<div>El nombre es requerido</div>);
      return;
    }


      const data = {
        id,
        email,
        role,
        username,
        password,
        machines: selectedMachines
      };

      // return console.log(data)
      post('users', data).then(r => {
        navigate(-1);
      }).catch(err => {
        console.log(err);
      });

  };

  return (
      <Form noValidate validated={validated}>


      <Row className="">
        <Col className='col-8'>


          <Form.Group className="mb-3" controlId="formGridAddress1">
            <Form.Label>Rol</Form.Label>
            <Form.Select
              value={role}
              onChange={(e) => setRole(e.target.value)}
              // onChange={handleChange(setRole)}
            >
              <option value=""></option>
              { context.user.role == 'ROOT' && <option value="ROOT">SUPER ADMIN</option> }
              <option value="ADMIN">ADMIN</option>
              <option value="USER">USER</option>
            </Form.Select>
            <div className="invalid-feedback">El rol es requerido</div>
          </Form.Group>

          <Form.Group className="mb-3" controlId="formGridAddress1">
            <Form.Label>Email</Form.Label>
            <Form.Control required type="text" value={email} onChange={handleChange(setEmail)} />
            <div className="invalid-feedback">El email es requerido</div>
          </Form.Group>

          <Form.Group className="mb-3" controlId="formGridAddress1">
            <Form.Label>Nombre</Form.Label>
            <Form.Control required type="text" value={username} onChange={handleChange(setUsername)} />
            <div className="invalid-feedback">El nombre es requerido</div>
          </Form.Group>

          <Form.Group className="mb-3" controlId="formGridAddress1">
            <Form.Label>Contraseña</Form.Label>
            <Form.Control required type="text" value={password} onChange={handleChange(setPassword)} />
          </Form.Group>

        </Col>
      </Row>



      <Row>
        { machines && machines.filter(machine => machine && machine.id)
          .map(machine => (
            <div key={machine.id} className='p-1'>
              <label>
                <input
                  type="checkbox"
                  className="me-1"
                  value={machine.id}
                  checked={ selectedMachines.indexOf(machine.id) > -1}
                  onChange={handleCheckboxChange}
                />
                {machine.id} - {machine.alias}
              </label>
            </div>
          ))
        }
      </Row>


      <div className='d-flex justify-content-end'>
        <Button onClick={e => handleSubmit(e)} variant="primary" type="button" className="me-2">Guardar</Button>
        <Button onClick={e => navigate(-1)} variant="secondary">Cancelar</Button>
      </div>
    </Form>
  );
}

export default GridComplexExample;